document.querySelectorAll('a[data-scroll-target]').forEach(a => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href') || '';
      if (!href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  const buyBoxMain = document.getElementById('buyBoxMainImg');
  const thumbs = Array.from(document.querySelectorAll('.buy-box__thumb'));
  function setActiveThumb(idx) {
    if (idx < 0) idx = thumbs.length - 1;
    if (idx >= thumbs.length) idx = 0;
    thumbs.forEach((t, i) => t.classList.toggle('buy-box__thumb--active', i === idx));
    const active = thumbs[idx];
    if (active && buyBoxMain) buyBoxMain.src = active.dataset.large || active.src;
  }
  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', () => setActiveThumb(idx));
  });
  const thumbPrev = document.getElementById('thumbPrev');
  const thumbNext = document.getElementById('thumbNext');
  function currentIdx() {
    return thumbs.findIndex(t => t.classList.contains('buy-box__thumb--active'));
  }
  if (thumbPrev) thumbPrev.addEventListener('click', () => setActiveThumb(currentIdx() - 1));
  if (thumbNext) thumbNext.addEventListener('click', () => setActiveThumb(currentIdx() + 1));

  /* Pricing tier selection — updates active state AND syncs the cart form's quantity hidden input.
     The Appstle bundle rule on this product applies its BOGO discount when the cart hits qty 3 or 6
     of this variant (or a mix of the 4 eligible bundle products). */
  document.querySelectorAll('.tier-card').forEach(card => {
    card.addEventListener('click', () => {
      document.querySelectorAll('.tier-card').forEach(c => c.classList.remove('tier-card--active'));
      card.classList.add('tier-card--active');
      const qty = card.dataset.qty || '1';
      const qtyInput = document.getElementById('wnnMagQty');
      if (qtyInput) qtyInput.value = qty;
      // Sync CTA button price to selected tier (data-cta-total is pre-rendered by Liquid)
      const ctaPriceEl = document.getElementById('checkoutCtaPrice');
      const ctaTotal = card.dataset.ctaTotal;
      if (ctaPriceEl && ctaTotal) ctaPriceEl.textContent = ctaTotal;
    });
  });

  (function stickyCtaFade(){
    const sticky = document.getElementById('stickyCta');
    if (!sticky) return;
    const hero = document.querySelector('.hero');
    if (!hero) return;
    const reveal = () => {
      const heroBottom = hero.getBoundingClientRect().top + window.scrollY + (hero.offsetHeight * 0.5);
      const isMobile = window.innerWidth < 1024;
      sticky.classList.toggle('is-visible', isMobile && window.scrollY > heroBottom);
    };
    window.addEventListener('scroll', reveal, { passive: true });
    window.addEventListener('resize', reveal, { passive: true });
    reveal();
  })();

  document.querySelectorAll('.faq__item').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        document.querySelectorAll('.faq__item').forEach(other => {
          if (other !== item) other.open = false;
        });
      }
    });
  });